import initTableGroupToggles from '../../_inte/js/components/ToggleTableGroups';

export default class SwitchView extends HTMLButtonElement {

    connectedCallback() {
        this.addEventListener('click', (e) => {
            e.preventDefault();

            if(document.getElementById('filter-checkbox-view-1').checked) {
                document.getElementById('filter-checkbox-view-1').removeAttribute('checked');
                document.getElementById('filter-checkbox-view-0').setAttribute('checked', true);
                document.getElementsByName('view')[0].dispatchEvent(new Event('change'));
            }
            else if(document.getElementById('filter-checkbox-view-0').checked) {
                document.getElementById('filter-checkbox-view-0').removeAttribute('checked');
                document.getElementById('filter-checkbox-view-1').setAttribute('checked', true);
                document.getElementsByName('view')[1].dispatchEvent(new Event('change'));
            }

            // Usage
            this.executeWhenAllAjaxComplete(() => {
                initTableGroupToggles();
                document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function(el) {
                    bootstrap.Tooltip.getOrCreateInstance(el);
                });
            });
        });
    }

    executeWhenAllAjaxComplete(callback) {
        if ($.active === 0) {
            // Aucune requête en cours
            callback();
        } else {
            // Attendre que toutes les requêtes se terminent
            $(document).ajaxStop(function () {
                $(this).off('ajaxStop'); // Éviter les répétitions
                callback();
            });
        }
    }
}
